<template>
  <v-speed-dial v-model="fab" right direction="right" class="ml-3">
    <template v-slot:activator>
      <v-btn hover icon small v-model="fab">
        <v-icon small>mdi-menu</v-icon>
      </v-btn>
    </template>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          v-if="item.id != ''"
          fab
          dark
          small
          color="blue"
          @click="$emit('editItem', item)"
        >
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <span>Edit {{ item.name }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" fab dark small color="green" @click="$emit('createItem', item)">
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>Add destination in {{ item.name }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          v-if="item.id != ''"
          fab
          dark
          small
          color="red"
          @click="$emit('deleteItem', item)"
        >
          <v-icon small color="white">mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>Remove {{ item.name }}</span>
    </v-tooltip>
  </v-speed-dial>
</template>

<script>
import ConfirmationDialog from "../../shared/ConfirmationDialog";

export default {
  name: "TreeviewDestinationsItemActions",

  components: {
    ConfirmationDialog
  },

  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    itemName: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      fab: false,
      show: false,
      question: "Are you sure?"
    };
  },

  computed: {
    itemLabel: function() {
      return this.item && this.item.node
        ? `${this.item.node.__typename}`
        : this.itemName || "Item";
    }
  },

  methods: {
    onRemoveAccept() {
      this.show = false;
      this.$emit("deleteItem", this.item);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/destinations/TreeviewDestinationsItemActions.vue